module.exports = __webpack_public_path__ + "img/perforaciones_16-9_2880.dc240b30.jpg";